<template>
	<div>
		<div class="warningMsg mb-3 p-3 " v-if="message != '' && messageType == 'error'">
		    <div class="infomsg d-flex align-items-center justify-content-between">
		        <div class="d-flex w-100 align-items-center">
					<p v-if="message == null || message == undefined" v-html="$t('TECH_ERROR')"></p>
		        	<p  v-else-if="message.substring(0,3) == 'BME'">
			            {{message.substring(3)}}<feather type="alert-circle"></feather>
			        </p>
					<p v-html="$t(message)" v-else>
			            <feather type="alert-circle"></feather>
			        </p>
		        </div>  
		        <feather type="x" @click.prevent="hideFunc()"></feather>  
		    </div> 
		</div>
		<div class="warningMsg successMsg mb-3 p-3 " v-if="message != '' && messageType == 'success'">
		    <div class="infomsg d-flex align-items-center justify-content-between">
		    	<div class="d-flex w-100 align-items-center">
			        <!-- <p v-html="$t(message)"> -->
			        <p>
			            <feather type="check"></feather>
			        </p>  
		        </div>  
		        <feather type="x" @click.prevent="hideFunc()"></feather>
		    </div> 
		</div>
	</div>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
		name: 'MessageComponent',
		mixins: [fxViewMixins],
		data() {
			return { }
		},
		props:['messageType','message'],
		methods:{
			hideFunc(){
				this.$parent.response_msg = ''
				this.message =''
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/message_component.vue